// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerCreatedScreen_container__3FP68","text":"CustomerCreatedScreen_text__1lJjb","check":"CustomerCreatedScreen_check__3juAe"};